<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchFactorialMaterialExport">
                    <input class="form-control mr-sm-2"
                           v-model="search.name"
                           type="search"
                           placeholder="ชื่อวัสดุ"
                           aria-label="Search"/>
                    <select class="form-control mr-sm-2 w-25"
                            v-model="search.source_id">
                        <option value="">แหล่งที่มา</option>
                        <option value="1">ในประเทศ</option>
                        <option value="2">นอกประเทศ</option>
                    </select>
                    <date-picker
                        v-model="search.date"
                        :format="changeFormat"
                        class="w-25"
                        :lang="lang"
                        placeholder="วันที่เบิก">
                    </date-picker>&nbsp;&nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchFactorialMaterialExport"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;&nbsp;
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">วันที่เบิก</th>
                    <th scope="col">ชื่อวัสดุ</th>
                    <th scope="col">แหล่งที่มา</th>
                    <th scope="col">จำนวนเบิก</th>
                    <th scope="col">หมายเหตุ</th>
                    <th scope="col">ชื่อผู้เบิก</th>
                    <th scope="col">ผู้บันทึก</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in factorialMaterialExportList">
                    <td>
                        {{ data.created_at | moment("DD/MM/YYYY") }}
                    </td>
                    <td>
                        <template v-if="data.factorial_material_details">
                            {{ data.factorial_material_details.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.factorial_material_details">
                            <template v-if="data.factorial_material_details.source_id == 1">
                                ในประเทศ
                            </template>
                            <template v-else>
                                นอกประเทศ
                            </template>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.quantity">
                            {{ data.quantity | amount }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        {{ data.remark }}
                    </td>
                    <td>
                        <template v-if="data.technical">
                            {{ data.technical }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>-</template>
                        &nbsp;&nbsp;
                    </td>
                    <td>
                        {{ data.updated_at | moment("DD/MM/YYYY , H:mm:ss") }}
                    </td>
                    <td>
                        <a @click="showFactorialMaterialExportModal(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="showModalDelete(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="factorialMaterialExportList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getFactorialMaterialExportList">
            </vue-pagination>
        </div>
        <br/>
        <b-modal
            hide-footer
            ref="export_data"
            id="import"
            title="เพิ่มวัตถุดิบเข้าคลัง">
            <factorial-material-export-modal @submit="saveEditExport">
            </factorial-material-export-modal>
        </b-modal>

        <!-- ----Modal Delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deleteExport"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalDelete">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--                <pre class="alert-primary">{{factorialMaterialExportList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import moment from "moment";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import FactorialMaterialExportModal from "./FactorialMaterialExportModal";

export default {
    name: "factorial-material-export",
    components: {
        FactorialMaterialExportModal,
        VuePagination,
        DatePicker
    },
    created() {
        this.$store.dispatch("FactorialMaterialExport/setFactorialMaterialExport");
        this.$store.dispatch("FactorialMaterialExport/clearFormData");
        this.$store.dispatch("FactorialMaterialExport/clearSearch");
    },
    data() {
        return {
            event_submit: false,
            id: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            factorialMaterialExportList: state => {
                return state.FactorialMaterialExport.factorialMaterialExportList
            },
            dataPaginate: state => {
                return state.FactorialMaterialExport.dataPaginate;
            },
            search: state => {
                return state.FactorialMaterialExport.search
            },
        })
    },
    methods: {
        showModalDelete(id) {
            this.id = id
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showFactorialMaterialExportModal(id) {
            this.showFactorialMaterialData(id);
            this.$refs.export_data.show();
        },
        hideFactorialMaterialExportModal() {
            this.$refs.export_data.hide();
        },
        showFactorialMaterialData(id) {
            this.$store.dispatch("FactorialMaterialExport/showFactorialMaterialExportByID", id).then(data => {
                this.$store.dispatch("FactorialMaterial/showFactorialMaterialByID", data.factorial_id);
            });
        },
        showFactorialMaterialByID(id) {
            this.$store.dispatch("FactorialMaterialExport/showFactorialMaterialExportByID", id).then(data => {
                this.$router.push("/factorial-material-information")
            });
        },
        getFactorialMaterialExportList() {
            const page = this.dataPaginate.current_page;
            //paginate search
            if (this.event_submit) {
                //change date format
                if (this.search.date) {
                    this.search.date = moment(this.search.date).format("YYYY-MM-DD");
                } else {
                    this.search.date = "";
                }
                let data = {
                    page: page,
                    name: this.search.name,
                    source_id: this.search.source_id,
                    date: this.search.date
                };
                this.$store.dispatch('FactorialMaterialExport/search', data)
            }
            //paginate get data
            else {
                this.$store.dispatch("FactorialMaterialExport/setFactorialMaterialExport", page);
            }
        },
        searchFactorialMaterialExport() {
            this.event_submit = true;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            this.$store.dispatch('FactorialMaterialExport/search', this.search)
        },
        saveEditExport(submitData) {
            //console.log('submitData')
            //console.log(submitData)
            if (submitData != 0) {
                this.$store.dispatch("FactorialMaterialExport/saveFactorialMaterialExport", submitData).then(() => {
                    this.$store.dispatch("FactorialMaterialExport/clearFormData")
                    this.$store.dispatch("FactorialMaterial/setFactorialMaterial");
                    this.$store.dispatch("FactorialMaterialExport/setFactorialMaterialExport");
                })
            }
            this.hideFactorialMaterialExportModal();
        },
        deleteExport() {
            //console.log(this.id)
            this.$store.dispatch('FactorialMaterialExport/delete', this.id).then(() => {
                this.$store.dispatch("FactorialMaterialExport/setFactorialMaterialExport");
                this.hideModalDelete()
            })
        }

    }
}
</script>

<style scoped>

</style>
